import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// 登录相关
export const rechargeRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/index'))),
    path: '/recharge',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/rechargeStatus'))),
    path: '/rechargeStatus',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/pointsList'))),
    path: '/pointsList',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/BankTransfer'))),
    path: '/BankTransfer',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/Fincode'))),
    path: '/fincode',
  },
  // 测试地址
  {
    element: lazyLoad(lazy(() => import('@/pages/recharge/FincodeLink'))),
    path: '/fincode_link',
  },
  //
]